module.exports = __webpack_public_path__ + "static/media/puerto_vallarta_Mexico.5eb0198f.png";